<template>
  <div :class="'search float-'+float" style="margin-left: 10px">
    <b-input-group class="my-3">
      <v-select
          id="filter_items"
          :options="options"
          name="filter_items"
          v-model="value"
          @input="updateValue($event)"
          :placeholder="placeholder"
          :clearable="false"
      />
      <b-input-group-append>
        <b-input-group-text class="searchinput">
          <b-icon icon="search" @click="searchHandler()" />
        </b-input-group-text>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>
<script>
export default {
  name: "FilterItems",
  props: {
    searchHandler: {
      type: Function,
      default: () => {
        console.warn("searchHandler prop is missing. This prop expect functionss")
      },
     },
    options: {
      type: Array,
      required: true
    },
    float:{
      Type: String,
      default: "right"
    },
    placeholder:{
      type: String,
      default: 'Select option',
    },

  },
  data() {
    return {
      value:{ id: "all", label: 'Select option'},
    }
  },
  methods: {
    updateValue: function (event) {
      this.value = event
      this.$emit('input', this.value)
    }
  }
}
</script>
<style lang="scss" scoped>
.searchinput {
  cursor: pointer;
}
</style>